import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { Ansible, PaginatedAnsibleResponse } from 'interfaces/ansible'

interface AnsibleFilters {
  page?: number // We'll convert this to offset internally
  limit?: number
  terminalId?: string
  status?: string
  name?: string
  minAvailableSlots?: number
  maxAvailableSlots?: number
  include?: string
}

const fetchAnsibles = async (
  filters: AnsibleFilters = {}
): Promise<PaginatedAnsibleResponse> => {
  const params = new URLSearchParams()

  // Convert page to offset (PNS uses offset-based pagination)
  if (filters.page && filters.limit) {
    const offset = (filters.page - 1) * filters.limit
    params.append('offset', offset.toString())
  }
  if (filters.limit) params.append('limit', filters.limit.toString())
  if (filters.terminalId) params.append('terminalId', filters.terminalId)
  if (filters.status) params.append('status', filters.status)
  if (filters.name) params.append('nameSearch', filters.name)
  if (filters.minAvailableSlots)
    params.append('minAvailableSlots', filters.minAvailableSlots.toString())
  if (filters.maxAvailableSlots)
    params.append('maxAvailableSlots', filters.maxAvailableSlots.toString())
  if (filters.include) params.append('include', filters.include)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/ansibles?${params.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useAnsibles = (filters: AnsibleFilters = {}) => {
  return useQuery(['ansibles', filters], () => fetchAnsibles(filters), {
    staleTime: 30000,
    retry: 2,
  })
}

export default useAnsibles
